export { default as SaleCard } from './SaleCard';
export { ISaleCardProps, SaleCardVariant } from './SaleCard.interfaces';
export { SaleCardSkeleton } from './SaleCardSkeleton/SaleCardSkeleton';
